import { useRef, useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { FEATURE_LEVEL, hasFeatureEnabled } from '../../../utils/featureConstants';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import styles from './styles';
import { UploadMembersProps } from './types';
import FormButton from '../../common/FormButton';

const UploadMembers = ({
    open,
    handleSubmit,
    handleCloseUploadPop,
    onKitNeedChange,
    validateExcelSheet,
    formValues,
    defaultSelectedPartner,
    submitting,
}: UploadMembersProps) => {
    const uploadInputRef = useRef<HTMLInputElement>(null);
    const [dataFile, setDataFile] = useState<File>();
    const [dragActive, setDragActive] = useState(false);

    function handleFile(file: File) {
        setDataFile(file);
        validateExcelSheet(file);
    }

    const onExcelUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            handleFile(e.target.files[0]);
        }
    };

    const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true);
        } else if (e.type === 'dragleave') {
            setDragActive(false);
        }
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        console.log('event', event);
        setDragActive(false);
        if (event.dataTransfer.files && event.dataTransfer.files[0]) {
            handleFile(event.dataTransfer.files[0]);
        }
    };

    return (
        <FormsPopup
            id="upload_members"
            open={open}
            title="Upload New Members"
            textAlign="left"
            handleClose={handleCloseUploadPop}
            description={<></>}
            width={474}
        >
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <Typography component="div" sx={styles.partnerContainer}>
                    <Typography sx={styles.title}>Selected Partner</Typography>
                    <Typography sx={styles.employerName}>{defaultSelectedPartner?.name}</Typography>
                </Typography>
                <Typography sx={styles.title}>Welcome Kit</Typography>
                <Typography component="div" sx={styles.mt_16}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formValues?.needs_welcome_kit === '1'}
                                onChange={(event) => {
                                    if (event.target.checked) onKitNeedChange('1');
                                }}
                                icon={<img alt="uncheck circle" src="/images/uncheck_cirlce.svg" />}
                                checkedIcon={<img alt="check circle" src="/images/check_cirlce.svg" />}
                            />
                        }
                        label={<Typography style={styles.plain_text}>Send Welcome Kit</Typography>}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formValues?.needs_welcome_kit === '0'}
                                onChange={(event) => {
                                    if (event.target.checked) onKitNeedChange('0');
                                }}
                                icon={<img alt="uncheck circle" src="/images/uncheck_cirlce.svg" />}
                                checkedIcon={<img alt="check circle" src="/images/check_cirlce.svg" />}
                            />
                        }
                        label={<Typography style={styles.plain_text}>Do not send Welcome Kit</Typography>}
                    />
                </Typography>
                <Typography sx={styles.note}>
                    Note: When Send Welcome Kit is selected, this will auto-send a welcome kit to these members.
                </Typography>
                <input ref={uploadInputRef} accept=".xlsx" type="file" hidden onChange={onExcelUpload} />
                {dataFile ? (
                    <Typography style={styles.plain_text}>
                        {dataFile.name}
                        <Button variant="contained" sx={styles.ml_16} onClick={() => uploadInputRef?.current?.click()}>
                            Change
                        </Button>
                    </Typography>
                ) : (
                    <Box
                        sx={[styles.uploadContainer, dragActive && styles.bw_2]}
                        onDragEnter={handleDrag}
                        onDragLeave={handleDrag}
                        onDragOver={handleDrag}
                        onDrop={handleDrop}
                        onClick={() => uploadInputRef?.current?.click()}
                    >
                        <img alt="file upload" src="/images/file_upload.svg" />
                        <Typography sx={styles.chooseFile}>Choose a file or drag it here.</Typography>
                    </Box>
                )}
                {hasFeatureEnabled(FEATURE_LEVEL.viewPartnerEmployer) && (
                    <FormButton
                        id="send_invitation_email"
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={styles.button}
                        disabled={!formValues?.data.length || submitting}
                        submitting={submitting}
                    >
                        Confirm Members and Send Invitation Email
                    </FormButton>
                )}
            </Box>
        </FormsPopup>
    );
};

export default UploadMembers;
